<template>
  <div class="honor-wrapper">
    <div class="honor-content img-wrap">
      <img :src="honorImg" alt="" />
    </div>
    <div class="honor-list">
      <ol>
        <li
          v-for="item in honorList"
          :class="[selected === item.FInterID ? 'selected' : '']"
          :key="item.FInterID"
          @click="selectedHonor(item)"
        >
          {{ formatName(item) }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      honorImg: "",
      honorList: []
    };
  },
  mounted() {
    this.$store.dispatch("getHonorData").then(res => {
      this.honorList = res.Data;
      this.selectedHonor(res.Data[0]);
    });
  },
  methods: {
    formatName(item) {
      let name;
      if (this.$i18n.locale === "zh") {
        name = item.FName;
      } else if (this.$i18n.locale === "en") {
        name = item.EnglishName;
      } else if (this.$i18n.locale === "sp") {
        name = item.xibanyaName;
      }
      return name;
    },
    selectedHonor(item) {
      this.selected = item.FInterID;
      this.honorImg = item.WebSite;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";
.honor-wrapper {
  width: 100%;
  height: 524px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .honor-content {
    width: 488px;
    height: 100%;
    margin-right: 40px;
  }

  .honor-list {
    flex: 1;
    height: 100%;
    overflow-y: auto;

    ol {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      li {
        width: 296px;
        height: 48px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(220, 220, 220, 1);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        line-height: 48px;
        color: rgba(85, 85, 85, 1);
        margin-bottom: 20px;
        cursor: pointer;
      }

      li:hover {
        background: @bgColor;
        color: #fff;
        border-color: @bgColor;
      }

      .selected {
        background: @bgColor;
        color: #fff;
        border-color: @bgColor;
      }
    }
  }

  .honor-list::-webkit-scrollbar-thumb {
    background: @bgColor;
  }
}
</style>
